/**
 * PageGridContext — allows the Header to trigger Edit Layout / Widgets
 * actions on whichever PageGrid is currently mounted on the page.
 *
 * Usage in PageGrid: call registerGrid(handlers) on mount, unregister on unmount.
 * Usage in Header: call triggerEdit() / triggerWidgets() from the buttons.
 */
import React, { createContext, useContext, useRef } from "react";

const PageGridContext = createContext(null);

export const PageGridProvider = ({ children }) => {
  const gridRef = useRef(null); // { openEdit, openWidgets }

  const registerGrid   = (handlers) => { gridRef.current = handlers; };
  const unregisterGrid = ()         => { gridRef.current = null; };
  const triggerEdit    = ()         => { gridRef.current?.openEdit?.(); };
  const triggerWidgets = ()         => { gridRef.current?.openWidgets?.(); };

  return (
    <PageGridContext.Provider value={{ registerGrid, unregisterGrid, triggerEdit, triggerWidgets }}>
      {children}
    </PageGridContext.Provider>
  );
};

export const usePageGrid = () => useContext(PageGridContext);
